var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 5,
    stroke: "#809E82",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86205 15.5949C8.78723 15.5924 8.71372 15.5746 8.64602 15.5427C8.57832 15.5108 8.51786 15.4654 8.46833 15.4092L4.75405 11.6949C4.68323 11.649 4.62377 11.5876 4.58015 11.5154C4.53654 11.4431 4.50991 11.3619 4.50228 11.2778C4.49465 11.1938 4.50622 11.1091 4.53611 11.0301C4.566 10.9512 4.61343 10.8801 4.67482 10.8222C4.73621 10.7643 4.80996 10.7211 4.8905 10.6958C4.97103 10.6706 5.05625 10.664 5.13972 10.6765C5.22319 10.689 5.30272 10.7203 5.37232 10.768C5.44192 10.8158 5.49976 10.8787 5.54147 10.9521L8.86205 14.2504L16.6398 6.49493C16.7445 6.42704 16.8689 6.39627 16.9932 6.40756C17.1175 6.41884 17.2344 6.47152 17.3252 6.55715C17.416 6.64279 17.4753 6.75642 17.4938 6.87984C17.5123 7.00325 17.4889 7.12931 17.4272 7.23779L9.25576 15.4092C9.20624 15.4654 9.14577 15.5108 9.07807 15.5427C9.01037 15.5746 8.93686 15.5924 8.86205 15.5949Z",
    fill: "#26342E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.b584b5992634b41ba6f347108c062394.svg";
export { ForwardRef as ReactComponent };